import React,{useState,useEvent, useEffect } from 'react'
import {register} from '../config/Variables';
function Register() {
  //if(localStorage.getItem('user-info')){
 // let user = JSON.parse(localStorage.getItem('user-info'))
//  }
  function logOut(){
    localStorage.clear();
  }
  const [email,setEmail] =useState();
  const [password,setPassword] =useState();
  const [device_name,setDevice] =useState();
  const [provider_id,setProviderid] =useState();
  const [provider,setProvider] =useState();
  const [first_name,setFirstname] =useState();
  const [last_name,setLastname] =useState();
  const [mobile,setMobile] =useState();
  const [profile_url,setProfileurl] =useState();

  //const history = useNavigate();
  useEffect(()=>{
   // if(localStorage.getItem('get-info')){
    //  history.push("/add");
    //}

  },[]);
 async function login(){

let item = {email, password, device_name};
let result = await fetch(register,{
  method: 'POST',
  headers : {
    "Content-Type" : "application/json",
    "Accept" : 'application/json'
  },
  body: JSON.stringify(item)
});

result =await result.json();
localStorage.setItem("user-info",JSON.stringify(result));
//history('/add');

  }
  return (
    <div>
      <h2><button  className="button submit-btn" onClick={logOut} >Logout </button></h2>

<input type="email" name="email" placeholder="Email" onChange={(e)=>setEmail(e.target.value)} />
  <input type="password" name="password"  placeholder="Password" onChange={(e)=>setPassword(e.target.value)}  /> 
<input type="text" name="device" placeholder="Device" onChange={(e)=>setDevice(e.target.value)} />
<input type="text" name="providerid" placeholder="Provider ID" onChange={(e)=>setProviderid(e.target.value)} />
<input type="text" name="provider" placeholder="Provider" onChange={(e)=>setProvider(e.target.value)} />
<input type="text" name="first_name" placeholder="first_name" onChange={(e)=>setFirstname(e.target.value)} />
<input type="text" name="last_name" placeholder="last_name" onChange={(e)=>setLastname(e.target.value)} />
<input type="text" name="mobile" placeholder="mobile" onChange={(e)=>setMobile(e.target.value)} />
<input type="text" name="profile_url" placeholder="profile_url" onChange={(e)=>setProfileurl(e.target.value)} />
<button onClick={login} className="button submit-btn" >  Login </button>       </div>
  );
}

export default Register;
